<template>
  <div class="md:container">
    <a-form :form="form" @submit.prevent="handleNote">
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/5">
          <h4 class="text-gray-900 text-lg"> {{editMode() ? 'Edit Note' : 'Add Note'}}</h4>
        </div>
        <div class="w-full md:w-4/5">
            <vx-card title="Note Information" class="p-0 md:p-3">
              <div class="grid grid-cols-1">
                <a-form-item label="Subject" has-feedback>
                  <a-input
                    v-decorator="['title',{ rules: [{ required: true, message: 'Please Enter Title Field.' }] }]"
                    autocomplete="none"
                  />
                </a-form-item>
                <a-form-item label="Note" has-feedback>
                  <a-textarea
                    v-decorator="['description',{ rules: [{ required: true, message: 'Please Enter description Field.' }] }]"
                    style="height: 120px"
                    autocomplete="none"
                  />
                </a-form-item>

                <div class="flex flex-col md:flex-row space-x-0 md:space-x-4 mt-5 md:mt-0">
                  <a-radio-group @change="setTypeNote" v-model="note_type" button-style="solid" class="self-center text-left mt-4" style="white-space: nowrap">
                    <a-radio-button value="matters">
                      Matters
                    </a-radio-button>
                    <a-radio-button value="contacts">
                      Contacts
                    </a-radio-button>
                  </a-radio-group>
                  <div v-show="is_type_note_contacts">
                      <selectSearch
                        @selectSearch="selectSearch"
                        :required="is_type_note_contacts"
                        :options="optionSearchContact"
                        class="mt-8 md:mt-0"
                        style="width:300px"
                      />
                  </div>
                  <div v-show="!is_type_note_contacts">
                      <selectSearch
                        @selectSearch="selectSearch"
                        :required="!is_type_note_contacts"
                        url="/matter/query/"
                        :options="optionSearchMatter"
                        class="mt-8 md:mt-0"
                        :is_include_matter="true"
                        style="width: 300px"
                      />
                  </div>
                </div>

                <a-form-item label="Date" has-feedback>
                  <a-date-picker
                    v-decorator="['date',{ initialValue: current_date,rules: [{ required: true, message: 'Please Enter Date Field.' }] }]"
                    :format="dateFormat"
                    class="w-full md:w-1/3"
                  />
                </a-form-item>

                <a-divider/>
                <h4>Recorded time</h4>
                <p>Add a time entry to this note</p>
                <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
                  <a-form-item label="Time" has-feedback>
                    <a-input
                      v-decorator="['recorded_time',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'', required: false }] }]"
                      placeholder="recorded Time"
                      autocomplete="none"
                      :disabled="!stop_time"
                      addon-after="hour"
                      class="recorded_time"
                    />
                  </a-form-item>
                  <Timer @Timer="(timing)=>timer(timing,form,'recorded_time')" @startTime="startTime" :time="time" ref="timer" class="timer md:mt-5"/>
                </div>
                <a-divider/>
                <h4>Notifications</h4>
                <p>Select firm users to receive notifications about this note.</p>
                <SelectOption
                  url="/account/list/"
                  label="Notification"
                  placeholder="notification"
                  field="notifications"
                  method="get"
                  mode="multiple"
                />
              </div>
            </vx-card>
        </div>
      </div>
      <br>
      <br>
      <br>
      <br>
      <Footer v-if="editMode ? hasPermission('note.edit') : hasPermission('note.create')" class="note-footer" url="/notes"/>
    </a-form>
  </div>
</template>

<script>

import Mixin from '../mixin/mixin'
import axios from '@/axios'
import selectSearch from "@/views/forms/selectSearch";
import SelectOption from "../forms/SelectOptionSingle"
import Timer from "@/layouts/components/timer/Timer";
import Footer from "@/views/footer/Footer";
import moment from 'moment'

export default {
  name: "AddNote",
  mixins: [Mixin],
  components: {
    selectSearch,
    SelectOption,
    Timer,
    Footer
  },
  data() {
    return {
      is_type_note_contacts: false,
      note_type: 'matters',
      rows: {},
      contact_or_matter: undefined,
      time: 0,
      stop_time: true
    }
  },
  methods: {

    handleNote() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$vs.loading()
            if(!values.notifications){
              values.notifications = []
            }
            if (this.editMode()) {
              if(values.contact)
                this.contact_or_matter ? values.contact = this.contact_or_matter : values.contact = this.rows.contact_id
              else
                this.contact_or_matter ? values.matter = this.contact_or_matter : values.matter = this.rows.matter.id
              await axios.put(`/note/${this.$route.params.id}/`, values)
            } else {
              await axios.post(`/note/`, values)
            }
            await this.$router.push('/notes')
            this.$notification['success']({
              message: 'Success',
              description: `Note ${this.editMode() ? 'updated' : 'created'}.`,
            });
          } catch (e) {
            this.$notification['error']({
              message: 'Error',
              description: `Please try again.`,
            });
          } finally {
            this.$vs.loading.close()
          }
        }
      })
    },

    setTypeNote({target: {value}}) {
      if (value === 'contacts') {
        this.is_type_note_contacts = true
        this.form.setFieldsValue({ matter: undefined })
      }else {
        this.is_type_note_contacts = false
        this.form.setFieldsValue({ contact: undefined })
      }
    },

    startTime(){
      this.stop_time = false
      // if(this.form.getFieldValue('recorded_time'))
      //   this.$refs.timer.formattedElapsedTime = this.form.getFieldValue('recorded_time') * 3600
    },

    async getItemNote() {
      try {
        this.$vs.loading()
        const {data} = await axios.get(`/note/${this.$route.params.id}/`)
        this.rows = data
        if (data.contact) {
          data.contact_id = data.contact.id
          data.contact = data.contact.person ? `${data.contact.person.first_name} ${data.contact.person.last_name}` : `${data.contact.company.name}`
          this.note_type = 'contacts'
          this.is_type_note_contacts = true
        }
        if (data.matter) {
          data.matter_id = data.matter.id
          data.matter = data.matter.title
        }
        this.$refs.timer.formattedElapsedTime = data.recorded_time * 3600
        this.time = data.recorded_time
        if(data.recorded_time === 0){
          data.recorded_time = undefined
        }
        if(data.notifications.length)
          data.notifications = data.notifications.map(item => item.id)
        else
          data.notifications = undefined
        this.$nextTick(() => {
          this.form.setFieldsValue(data)
        })
      } catch (e) {
        this.$notification['error']({
          message: 'Error',
          description: `Server error`,
        });
      } finally {
        this.$vs.loading.close()
      }
    },

    selectSearch(val) {
      this.contact_or_matter = val
    },

    setTimeToTimer({target:{value}}){
      this.$refs.timer.formattedElapsedTime = value
    }

  },
  computed:{
    current_date(){
      return new Date().toISOString()
    }
  },
  mounted() {
    if (this.editMode()) {
      this.getItemNote()
    }
  }
}
</script>

<style>
  @import "../style/style.css";

  .vs-card--content{
    margin-bottom: 0 !important;
  }


</style>
